module.exports = __webpack_public_path__ + "static/rules-bottom-desc-bg-d298b5fa88360a120621663f7aeac0e6.svg";